import React, { useState } from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import ProgressBar from "./ProgressBar";
import { expenseData } from "../data/expenseData";
import { DateTime } from "luxon";
import { apiCreateExpense } from "../services/apiService";

const initialErrorState = {
  type: "",
  datePaid: "",
  payee: "",
  description: "",
  roomId: "",
  subtotal: "",
  tax: "",
};

const descLength = 300;

const AddExpenseModal = (props) => {
  const { currentProperty } = props;
  const { user, rooms, setExpenses, handleModal } = useStateContext();
  const [addRoom, setAddRoom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(initialErrorState);
  const [count, setCount] = useState(descLength);
  const [page, setPage] = useState(1);
  const pages = 7;

  const currentRooms = rooms
    .filter((x) => x.propertyId === currentProperty.id)
    .map((x, index) => {
      return { id: index, roomId: x.id, name: x.roomName };
    });

  console.log(currentProperty);

  const [expense, setExpense] = useState({
    landlordId: user.id,
    propertyId: currentProperty.id,
    type: "--",
    datePaid: "",
    payee: "",
    generalDesc: "",
    description: "",
    roomId: "",
    images: "",
    subtotal: "",
    tax: "",
    total: "",
  });

  const nextPage = () => {
    if (hasErrors()) {
      return;
    } else {
      if (page === 6) calculateTotal();
      setPage(page + 1);
    }
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const reg = new RegExp("^(?:[0-9]+(\\.[0-9]{1,2})?|)$"); // fixed to 2-decimal places or empty sting

    if (name === "description") setCount(descLength - value.length);
    if (name === "type") {
      const typeDesc = expenseData.find((x) => x.name === value).description;
      setExpense((prevState) => ({
        ...prevState,
        [name]: value,
        generalDesc: typeDesc,
      }));
      return;
    }
    if (name === "addRoom") {
      setAddRoom(value === "true" ? true : false);
      if (value === "false")
        setExpense((prevState) => ({ ...prevState, roomId: "" }));
      return;
    }
    if (name === "subtotal" || name === "tax") {
      if (reg.test(value)) {
        setExpense((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        return;
      }
    }

    setExpense((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const addExpense = async () => {
    setIsLoading(true);
    const response = await apiCreateExpense(expense);
    if (response.hasError) {
      setIsLoading(false);
      console.log(response.error.response.statusText);
    } else {
      setExpenses((prevState) => [...prevState, response.data]);
      setIsLoading(false);
      handleModal("addExpense");
    }
  };

  const calculateTotal = () => {
    setExpense((prevState) => ({
      ...prevState,
      subtotal: Number(expense.subtotal),
      tax: Number(expense.tax),
      total: Number(expense.subtotal) + Number(expense.tax),
    }));
  };

  const hasErrors = () => {
    if (page === 2 && expense.type === "--") {
      activateError("type");
      return true;
    } else if (page === 3 && expense.datePaid === "") {
      activateError("datePaid");
      return true;
    } else if (page === 3 && expense.payee === "") {
      activateError("payee");
      return true;
    } else if (page === 5 && addRoom === true && expense.roomId === "") {
      activateError("roomId");
      return true;
    } else if (page === 6 && expense.subtotal === "") {
      activateError("subtotal");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  console.log(expense);

  return (
    <div
      className="w-screen h-screen fixed top-0 left-0 right-0 bg-white
    overflow-y-scroll mt-20 z-10"
    >
      <ProgressBar pages={pages} currentPage={page} />
      <form
        className="grid justify-items-center"
        onSubmit={(e) => {
          e.preventDefault();
          page === pages ? addExpense() : nextPage();
        }}
      >
        {page === 1 && (
          <>
            <div className="flex justify-center text-lg mt-10">Add Expense</div>
            <div className="flex justify-center px-10">
              <div
                className="max-w-[500px] text-center bg-gray-100 border-gray-400 
                border-2 rounded-2xl mt-10 p-5"
              >
                Add expenses to keep track of what you are spending on this
                property.
              </div>
            </div>
          </>
        )}
        {page === 2 && (
          <>
            <label>
              <div className={`flex justify-center mt-10 mb-5 ${error.type}`}>
                What type of expense is this?
                <span className="text-red-500">*</span>
              </div>
              <select
                id="type"
                name="type"
                value={expense.type}
                className={`w-52 border-black border-1 ${error.type}`}
                autoFocus={true}
                onChange={handleChange}
              >
                <option disabled>--</option>
                {expenseData.map((item, index) => {
                  return (
                    <option key={item.id} value={item.name}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </label>
            {expense.type !== "--" && (
              <div className="px-5">
                <div
                  className="max-w-[500px] text-center bg-gray-100 border-gray-400 
                border-2 rounded-2xl mt-10 p-5"
                >
                  <div>IDEAL FOR:</div>
                  <div className="mt-2">{expense.generalDesc}</div>
                </div>
              </div>
            )}
          </>
        )}
        {page === 3 && (
          <>
            {/* {expense.payee && ( */}
            <label>
              <div className={`flex justify-start mt-10 ${error.datePaid}`}>
                Date of payment:
                <span className="text-red-500">*</span>
              </div>
              <input
                id="date-paid"
                name="datePaid"
                type="date"
                max={DateTime.now().toFormat("yyyy-MM-dd")}
                value={expense.datePaid}
                autoFocus={true}
                className={`w-72 border-gray-300 border-1 rounded-md p-2 ${error.datePaid}`}
                onChange={handleChange}
              />
            </label>
            {/* )} */}
            <label>
              <div className={`flex justify-start mt-10 ${error.payee}`}>
                Payee's Name:
                <span className="text-red-500">*</span>
              </div>
              <input
                id="payee"
                name="payee"
                type="text"
                maxLength={30}
                placeholder="Joe's Plumbing Co."
                value={expense.payee}
                className={`w-72 border-gray-300 border-1 rounded-md p-2 ${error.payee}`}
                onChange={handleChange}
              />
            </label>
          </>
        )}
        {page === 4 && (
          <>
            <label>
              <div className="flex justify-start text-left mt-10">
                Additional notes or description:
              </div>
              <textarea
                id="description"
                name="description"
                type="text"
                maxLength={descLength}
                placeholder="EX: Water leak on the second floor."
                value={expense.description}
                autoFocus={true}
                className="w-72 h-40 border-gray-300 border-1 rounded-lg p-2"
                onChange={handleChange}
              />
              <div
                className={`flex justify-end ${
                  count === 0 ? "animate-shake text-red-600" : ""
                }`}
              >
                {count}
              </div>
            </label>
          </>
        )}
        {page === 5 && (
          <>
            <label className="grid justify-items-center">
              <div className="flex justify-center mt-10 mb-2">
                Assign this expense to a particular room?
                {/* <span className="text-red-500">*</span> */}
              </div>
              <select
                id="add-room"
                name="addRoom"
                value={addRoom}
                className="w-52 border-gray-300 border-1 rounded-md p-2"
                autoFocus={true}
                onChange={handleChange}
              >
                <option value={false}>No</option>
                <option value={true}>Yes</option>
              </select>
            </label>
            {addRoom && (
              <div className="mt-5">
                <div className={`mt-10 ${error.roomId}`}>
                  Select Room:
                  <span className="text-red-500">*</span>
                </div>
                <select
                  id="room-id"
                  name="roomId"
                  value={expense.roomId}
                  className={`w-52 border-gray-300 border-1 rounded-md 
                    p-2 capitalize ${error.roomId}`}
                  autoFocus={true}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    --
                  </option>
                  {currentRooms.map((item, index) => {
                    return (
                      <option key={item.id} value={item.roomId}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}
          </>
        )}
        {page === 6 && (
          <>
            <label className="grid">
              <div
                className={`flex justify-start text-lg mt-10 mb-1 ${error.subtotal}`}
              >
                Subtotal:
                <span className="text-red-500">*</span>
              </div>
              <div className="flex relative">
                <div className="absolute p-2">$</div>
                <input
                  id="subtotal"
                  name="subtotal"
                  type="number"
                  maxLength={6}
                  placeholder="0.00"
                  value={expense.subtotal || ""}
                  className={`w-40 text-right border-gray-300 border-1 
                    rounded-md p-2 ${error.subtotal}`}
                  onChange={handleChange}
                />
              </div>
            </label>
            <label className="grid">
              <div className="text-lg text-justified mt-5">Tax:</div>
              <div className="flex relative">
                <div className="absolute p-2">$</div>
                <input
                  id="tax"
                  name="tax"
                  type="number"
                  maxLength={6}
                  placeholder="0.00"
                  value={expense.tax || ""}
                  className="w-40 text-right border-gray-300 border-1 rounded-md p-2"
                  onChange={handleChange}
                />
              </div>
            </label>
            <div className="flex text-2xl mt-10 gap-x-2">
              <div>Total:</div>
              {expense.subtotal === "" ? (
                <div>$0.00</div>
              ) : (
                <div>
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(Number(expense.subtotal) + Number(expense.tax))}
                </div>
              )}
            </div>
          </>
        )}
        {page === 7 && (
          <>
            <div className="px-5 mt-5">
              <div className="border-gray-300 border-2 bg-gray-200 rounded-xl text-lg p-5 mt-5">
                <div className="flex justify-center text-3xl">New Expense:</div>

                <div className="flex justify-center gap-x-2 mt-5">
                  <div>Date:</div>
                  <div
                    className="text-right text-blue-500 hover:text-blue-700 cursor-pointer"
                    onClick={() => setPage(3)}
                  >
                    {DateTime.fromFormat(
                      expense.datePaid,
                      "yyyy-mm-dd"
                    ).toFormat("mm/dd/yyyy")}
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-5">
                  <div>To:</div>
                  <div
                    className="w-56 text-right col-span-3 text-blue-500
                   hover:text-blue-700 cursor-pointer"
                    onClick={() => setPage(3)}
                  >
                    {expense.payee}
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-2">
                  <div>For:</div>
                  <div
                    className="w-56 text-right col-span-3 text-blue-500
                   hover:text-blue-700 cursor-pointer"
                    onClick={() => setPage(2)}
                  >
                    {expense.type}
                  </div>
                </div>
                <div className="grid grid-cols-2 mt-2">
                  <div>Subtotal:</div>
                  <div
                    className="text-right text-blue-500
                   hover:text-blue-700 cursor-pointer"
                    onClick={() => setPage(6)}
                  >
                    {Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(expense.subtotal)}
                  </div>
                </div>
                <div className="grid grid-cols-2 mt-2">
                  <div>Tax:</div>
                  <div
                    className="text-right text-blue-500
                 hover:text-blue-700 cursor-pointer"
                    onClick={() => setPage(6)}
                  >
                    {Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(expense.tax)}
                  </div>
                </div>
                <div className="grid grid-cols-2 text-2xl mt-5">
                  <div>Total:</div>
                  <div className="text-right text-2xl">
                    {Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(expense.total)}
                  </div>
                </div>
              </div>
              {/* <div className="flex justify-center gap-x-5 text-3xl mt-5">
                <div>Total:</div>
                <div className="place-self-end">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(expense.total)}
                </div>
              </div> */}
            </div>
          </>
        )}
        {page === pages && <></>}
      </form>
      <div className="flex justify-center w-full fixed top-[525px]">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === 1 ? "Close" : "Back"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={page === 1 ? () => handleModal("addExpense") : prevPage}
        />
        <Button
          isDisabled={isLoading}
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={page === pages ? "Submit" : "Next"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={page === pages ? addExpense : nextPage}
        />
      </div>
      <div className="mb-[300px]"></div>
    </div>
  );
};

export default AddExpenseModal;
